// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"fdf7270c","56":"b39b4d13","65":"c6b145a6","104":"70a0668b","296":"bf2e5d09","443":"946c1bca","484":"94244a0a","796":"df7a5ab6","824":"15dd2c89","853":"5e5c6497","928":"1fbcd28c"}[chunkId] + ".chunk.js";
};